import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import Logger from 'browser-logging/src/browser/Logger';

import App from './App';
import './MuiLicense';

Logger.init({
  appName: `${import.meta.env.VITE_PRODUCT_ID} Client`.replaceAll(' ', '_'),
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
